import { colorOptions } from '../../components/CanvasEditor/components/Color/colorOptions';
import { thicknessOptions } from '../../components/CanvasEditor/components/Thickness/thicknessOptions';

const initialState = {
  color: colorOptions[0], // red
  selectedThickness: thicknessOptions[1], // md
  toolbarOptionsPanel: '', // thickness | color
  cursorTooltip: '',

  // NEW
  fabricCanvases: {}, // { [pageNumber]: fabric.Canvas }
  activePage: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'canvas_editor/UPDATE_OVERLAY':
      return {
        ...state,
        fabricOverlay: action.fabricOverlay,
        viewer: action.viewer,
      };

    case 'canvas_editor/UPDATE_TOOL': {
      return {
        ...state,
        activeTool: action.tool,
        toolbarOptionsPanel: '',
      };
    }

    case 'canvas_editor/UPDATE_COLOR': {
      return {
        ...state,
        color: action.color,
      };
    }

    case 'canvas_editor/UPDATE_THICKNESS':
      return {
        ...state,
        selectedThickness: action.thickness,
      };

    case 'canvas_editor/SET_ACTIVE_OBJECT': {
      return {
        ...state,
        activeObject: action.object,
      };
    }

    case 'canvas_editor/SET_TOOLBAR_OPTIONS_PANEL': {
      return {
        ...state,
        toolbarOptionsPanel: action.options_panel,
      };
    }

    case 'canvas_editor/SET_CURSOR_TOOLTIP': {
      return {
        ...state,
        cursorTooltip: action.text,
      };
    }

    // NEW ACTIONS FOR MULTI-CANVAS SUPPORT

    case 'canvas_editor/REGISTER_CANVAS': {
      const { pageNumber, canvas } = action.payload;
      return {
        ...state,
        fabricCanvases: {
          ...state.fabricCanvases,
          [pageNumber]: canvas,
        },
      };
    }

    case 'canvas_editor/SET_ACTIVE_PAGE': {
      return {
        ...state,
        activePage: action.payload,
      };
    }

    case 'canvas_editor/UNREGISTER_CANVAS': {
      const { pageNumber } = action.payload;
      const newCanvases = { ...state.fabricCanvases };
      delete newCanvases[pageNumber];

      return {
        ...state,
        fabricCanvases: newCanvases,
        activePage: state.activePage === pageNumber ? null : state.activePage,
      };
    }

    case 'canvas_editor/CLEAR_ALL_CANVASES': {
      return {
        ...state,
        fabricCanvases: {},
        activePage: null,
      };
    }

    default:
      return state;
  }
}
